module.exports = __webpack_public_path__ + "img/0Q3A7263_L_Black_MockedUp.02119ee4.jpg";